var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-4"},[_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":("/tasks/" + _vm.taskId + "/files/" + _vm.fileUploadId),"alt":_vm.alt,"width":_vm.width}})])}
var staticRenderFns = []

export { render, staticRenderFns }